import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetAllLocalizationDto } from "src/app/store/localization/localization.action";

export function FlatViewResolver() {
    return inject(Store).dispatch(new GetAllLocalizationDto());
}